import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-reactive-table',
  templateUrl: './reactive-table.component.html',
  styleUrls: ['./reactive-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReactiveTableComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
